import { Field, useFormikContext } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '../../../atoms/Button';
import EmailField from '../../../fields/EmailField';
import FirstNameField from '../../../fields/FirstNameField';
import LastNameField from '../../../fields/LastNameField';
import PasswordField from '../../../fields/PasswordField';
import SelectField from '../../../formik/SelectField';
import DynamicFieldArea from '../../DynamicFieldArea';
import ThirdPartySignIn, { getThirdParties } from '../ThirdPartySignIn';

const Register = () => {
  const { formatMessage } = useIntl();
  const { submitForm, isSubmitting } = useFormikContext();

  const parties = getThirdParties();
  const testIdPrefix = 'register';

  return (
    <>
      <div className="form__row">
        <div className="form__field-container">
          <Field
            name="gender"
            component={SelectField}
            label={formatMessage({ id: 'generic.salutation.label' })}
            options={['f', 'm'].map(value => ({
              label: formatMessage({ id: `generic.salutation.options.${value}` }),
              value,
            }))}
          />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <FirstNameField testIdPrefix={testIdPrefix} />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <LastNameField testIdPrefix={testIdPrefix} />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <EmailField testIdPrefix={testIdPrefix} />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container">
          <PasswordField testIdPrefix={testIdPrefix} type="register" />
        </div>
      </div>
      <DynamicFieldArea area="register" />
      <div className="form__row">
        <div className="form__field-container">
          <Button
            type="button"
            onClick={() => submitForm()}
            data-test-id="register-submit"
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            <FormattedMessage id="auth.options.register.submit" />
          </Button>
        </div>
      </div>
      {parties.length > 0 && (
        <>
          <div className="auth-form__divider">
            <span className="auth-form__divider-line auth-form__divider-line--left"></span>
            Or
            <span className="auth-form__divider-line auth-form__divider-line--right"></span>
          </div>
          <ThirdPartySignIn parties={parties} />
        </>
      )}
    </>
  );
};

export default Register;
